<ng-container formGroupName="foreignCountryTaxDetails">
  <div class="ba-field-group">
    <ibk-input-group>
      <label>País de residencia fiscal (*)</label>
      <ibk-select class="field" dsRxForm="selectChange" formControlName="country">
        <ibk-select-option
          *ngFor="let option of paramsService.params$('country') | async"
          [value]="option.value"
          [label]="option.label"
        ></ibk-select-option>
      </ibk-select>
    </ibk-input-group>

    <ibk-input-group>
      <label>Ciudad</label>
      <ibk-input class="field">
        <input formControlName="city" class="field" type="text" />
      </ibk-input>
    </ibk-input-group>
  </div>

  <div class="ba-field-group">
    <ibk-input-group>
      <label>Dirección legal</label>
      <ibk-input class="field">
        <input formControlName="legalAddress" class="field" maxlength="38" type="text" />
      </ibk-input>
    </ibk-input-group>
  </div>

  <div class="ba-field-group">
    <ibk-input-group>
      <label> Mi registro o N° tributario (NIT/RUT/TIN) es: </label>
      <p class="description">
        Número equivalente al RUC peruano que tenga ante las autoridades tributarias de otros países.
      </p>
      <ibk-input class="field">
        <input formControlName="taxNumber" class="field" type="text" />
      </ibk-input>
    </ibk-input-group>
  </div>

  <ibk-input>
    <input formControlName="countryDoesNotRequireTaxNumber" type="checkbox" />
    El país de residencia fiscal no exige registro o número tributario.
  </ibk-input>
</ng-container>
